module.exports = __webpack_public_path__ + "static/media/machine_learning.ba0affa7.png";